import LabelLang, { LabelLangString } from "component/LabelLang/label-lang.js";

function DataRequestSelectField({
  label,
  dir,
  currentLocale,
  registerProps,
  options,
}) {
  return (
    <div className="form-label row">
      <div className="col-lg-4">
        <label>{label}</label>
      </div>
      <div className="col-lg-8">
        <div className="dropdown">
          <select
            className={`${dir === "rtl" ? "r-dir" : "l-dir"}`}
            {...registerProps}
          >
            {options.map(({ id, name, Translation }, i) => (
              <option
                key={i}
                value={id}
                title={LabelLangString({
                  id: "name",
                  currentLocale,
                  defaultValue: name,
                  translations: Translation,
                })}
              >
                <LabelLang
                  id="name"
                  defaultValue={name}
                  translations={Translation}
                />
              </option>
            ))}
          </select>
          <span>*</span>
        </div>
      </div>
    </div>
  );
}

export default DataRequestSelectField;
